/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";

export enum ProtocolEnum {
  "HTTPS" = "HTTPS",

  "HTTP" = "HTTP"
}

export enum Protocol_4modEnum {
  "HTTPS" = "HTTPS",

  "HTTP" = "HTTP"
}

export enum Redirect_protocolEnum {
  "HTTPS" = "HTTPS",

  "HTTP" = "HTTP"
}

// required attributes
const StationDetailsR = t.interface({
  broker_code: t.string,

  enabled: withDefault(t.boolean, true),

  flag_standin: t.boolean,

  port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  primitive_version: t.union([
    WithinRangeInteger<1, 2, IWithinRangeIntegerTag<1, 2>>(1, 2),
    t.literal(2)
  ]),

  protocol: enumType<ProtocolEnum>(ProtocolEnum, "protocol"),

  station_code: t.string,

  thread_number: t.Integer,

  timeout_a: NonNegativeInteger,

  timeout_b: NonNegativeInteger,

  timeout_c: NonNegativeInteger,

  version: t.union([
    WithinRangeInteger<1, 2, IWithinRangeIntegerTag<1, 2>>(1, 2),
    t.literal(2)
  ])
});

// optional attributes
const StationDetailsO = t.partial({
  broker_description: t.string,

  flag_online: t.boolean,

  invio_rt_istantaneo: t.boolean,

  ip: t.string,

  ip_4mod: t.string,

  is_connection_sync: t.boolean,

  is_payment_options_enabled: t.boolean,

  password: t.string,

  pof_service: t.string,

  port_4mod: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  protocol_4mod: enumType<Protocol_4modEnum>(
    Protocol_4modEnum,
    "protocol_4mod"
  ),

  proxy_enabled: t.boolean,

  proxy_host: t.string,

  proxy_password: t.string,

  proxy_port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  proxy_username: t.string,

  redirect_ip: t.string,

  redirect_path: t.string,

  redirect_port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  redirect_protocol: enumType<Redirect_protocolEnum>(
    Redirect_protocolEnum,
    "redirect_protocol"
  ),

  redirect_query_string: t.string,

  rest_endpoint: t.string,

  service: t.string,

  service_4mod: t.string,

  target_host: t.string,

  target_host_pof: t.string,

  target_path: t.string,

  target_path_pof: t.string,

  target_port: t.Integer,

  target_port_pof: t.Integer
});

export const StationDetails = t.intersection(
  [StationDetailsR, StationDetailsO],
  "StationDetails"
);

export type StationDetails = t.TypeOf<typeof StationDetails>;
